import { render, staticRenderFns } from "./addAdmin.vue?vue&type=template&id=1010c7f8&scoped=true&"
import script from "./addAdmin.vue?vue&type=script&lang=js&"
export * from "./addAdmin.vue?vue&type=script&lang=js&"
import style0 from "./addAdmin.vue?vue&type=style&index=0&id=1010c7f8&scoped=true&rel=stylesheet%2Fscss&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1010c7f8",
  null
  
)

export default component.exports